module.exports = __webpack_public_path__ + "593a3d53/img/delete-icon.eb7de062.svg";